exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "/**\r\n * Main Layout\r\n */\n.layout-container {\n  display: block;\n  position: relative;\n  width: 100%;\n  height: 100%; }\n\n.main-container {\n  position: relative;\n  height: calc(100% - 65px);\n  overflow: auto; }\n  @media only screen and (min-width: 992px) {\n    .main-container {\n      margin-left: 262px; } }\n  .main-container > section {\n    min-height: calc(100% - 60px); }\n\n.content-heading {\n  padding: 16px;\n  box-shadow: 0 1px 0 rgba(20, 20, 20, 0.075); }\n\nfooter {\n  left: 0;\n  right: 0;\n  bottom: 0;\n  height: 60px;\n  border-top: 1px solid rgba(160, 160, 160, 0.12);\n  padding: 20px;\n  z-index: 109; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/layout/layout.component.scss
// module id = 1167
// module chunks = 4